"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
class MultilingualTypeHelper {
    /**
     * Create new blank Multilingual String instance
     * @param  {Array<Language>} languages - Available language list
     * @return {MultilingualString}
     */
    static createBlankMultilingualString(languages) {
        let multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        let languageIds = languages.map((item) => {
            return item.getId();
        });
        multilingualStringBuilder.withValueForLanguages(languageIds, null);
        return multilingualStringBuilder.build();
    }
    /**
     * Serialize Multilingual String to JSON object
     * @param  {MultilingualString} multilingualProperty - Object for serialization
     * @return {any}                                       Serialized JSON
     */
    static serializeMultilingualString(multilingualProperty) {
        let json = {};
        let map = multilingualProperty ? multilingualProperty.toMap() : new Map();
        for (let obj of Array.from(map)) {
            json[obj[0]] = obj[1];
        }
        return json;
    }
    /**
     * Deserialize JSON object to Multilingual String
     * @param  {any}                jsonObject - JSON Object for deserialization
     * @return {MultilingualString}              Serialized Multilingual String
     */
    static deserializeMultilingualString(jsonObject) {
        let map = new Map();
        for (let obj in jsonObject) {
            map.set(Number.parseInt(obj), jsonObject[obj]);
        }
        let multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        multilingualStringBuilder.fromMap(map);
        return multilingualStringBuilder.build();
    }
}
exports.MultilingualTypeHelper = MultilingualTypeHelper;
//# sourceMappingURL=multilingual-type-helper.js.map